import React from 'react';
import { useFormikContext } from 'formik';
import { Input, RadioGroup, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';
import { TypeOnlyOptions } from '../../forms/cartoon/constants';
export var CARTOON_CITING_SECTION_ID = 'cartoon-citing-section';
export var CARTOON_CITING_SECTION_TEST_ID = 'cartoon-citing-section-test-id';

/** cartootn input ids */
export var CARTOON_TITLE_INPUT_TEST_ID = 'cartoon-title-test-id';
/** radio group options, title for "Type" field + testIds for that field */
export var CARTOON_TYPE_RADIO_INPUT_TEST_ID = 'cartoon-type-radio-input-test-id';
export var CARTOON_TYPE_RADIO_INPUT_TITLE = 'Type';
export var CartoonCitingSection = function CartoonCitingSection(_ref) {
  var selectedTab = _ref.selectedTab;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var typeRadioGroupOnChangeHandler = function typeRadioGroupOnChangeHandler(options) {
    setFieldValue('cartoon.type', options.key);
  };
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: CARTOON_CITING_SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(CARTOON_CITING_SECTION_ID, "-label"),
    dataTestId: CARTOON_CITING_SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "cartoon.title",
    labelText: "Cartoon title",
    "data-test": CARTOON_TITLE_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(RadioGroup, {
    options: TypeOnlyOptions,
    legend: CARTOON_TYPE_RADIO_INPUT_TITLE,
    name: "".concat(selectedTab, ".cartoon.type"),
    formikFieldName: "cartoon.type",
    align: "vertical",
    "data-test": CARTOON_TYPE_RADIO_INPUT_TEST_ID,
    onChange: typeRadioGroupOnChangeHandler
  }));
};